<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="Loading..."
      ref="table"
      :row-key="rowKeyHandler"
      :expand-row-keys="expandRowKeys"
    >
      <el-table-column type="expand">
        <template slot-scope="{ row }">
          <div class="field-changes-wrap">
            <el-table
              :data="row.fieldChanges"
              border
              size="mini"
              :show-header="true"
            >
              <el-table-column
                prop="fieldName"
                label="Field Name"
                min-width="160"
              />
              <el-table-column
                prop="oldValue"
                label="Old Value"
                min-width="200"
                show-overflow-tooltip
              />
              <el-table-column
                prop="newValue"
                label="New Value"
                min-width="200"
                show-overflow-tooltip
              />
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Update Type" min-width="140" align="center">
        <template slot-scope="{ row }">
          <el-tag
            :type="updateTypeTagType(row.updateType)"
            effect="dark"
            size="mini"
          >
            {{ row.updateType }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Update Time" min-width="180" align="center">
        <template slot-scope="{ row }">
          {{ formatTime(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="operatorName"
        label="Operator Name"
        min-width="160"
        show-overflow-tooltip
      />
    </el-table>
    <div class="pagination-wrap">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationLog",
  data() {
    return {
      tableLoading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      expandRowKeys: [],
    };
  },
  computed: {
    seId() {
      return this.$route.params.seId;
    },
  },
  created() {
    this.getTableData();
  },
  methods: {
    rowKeyHandler(row) {
      return row.operationId;
    },
    updateTypeTagType(updateType) {
      switch (updateType) {
        case "CREATE":
          return "success";
        case "UPDATE":
          return "warning";
        case "DELETE":
          return "danger";
        case "TRANSFER":
          return "primary";
        default:
          return "info";
      }
    },
    formatTime(time) {
      if (!time) return "";
      // 后端已返回格式化文本时直接展示，避免 Date 解析引入时差
      if (typeof time === "string" && !time.includes("T")) return time;
      return this.moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
    },
    isEmptyValue(value) {
      return value === null || value === undefined || String(value).trim() === "";
    },
    displayFieldValue(fieldName, value, updateType) {
      const type = String(updateType || "").toUpperCase();
      if (
        String(fieldName || "").toUpperCase() === "MSL" &&
        this.isEmptyValue(value) &&
        type !== "CREATE"
      ) {
        return "未挂靠";
      }
      return this.isEmptyValue(value) ? "" : value;
    },
    normalizeTableData(list) {
      return (list || []).map((item) => {
        const updateType = item.updateType;
        return {
          ...item,
          fieldChanges: (item.fieldChanges || []).map((fc) => ({
            ...fc,
            oldValue: this.displayFieldValue(
              fc.fieldName,
              fc.oldValue,
              updateType,
            ),
            newValue: this.displayFieldValue(
              fc.fieldName,
              fc.newValue,
              updateType,
            ),
          })),
        };
      });
    },
    getTableData() {
      this.tableLoading = true;
      this.axios
        .get("/se/operationLogs", {
          params: {
            seId: this.seId,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(({ code, data, msg }) => {
          this.tableLoading = false;
          if (code === 200) {
            const payload = data || {};
            this.tableData = this.normalizeTableData(payload.list || []);
            this.total = payload.total || 0;
          } else {
            this.$message.error(msg || "Load operation logs failed.");
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.field-changes-wrap {
  padding: 10px 20px 10px 50px;
}
</style>
